"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cuid = require("cuid"); // create id compatible for every browsers


var createId = function createId() {
  return cuid();
};

var getInputId = function getInputId(id) {
  if (id) {
    return id;
  }

  return createId();
};

var getFirstId = function getFirstId(options) {
  return !options && options.length > 0 ? options[0].id : '';
};

var getOptionsWithId = function getOptionsWithId(options) {
  return options.map(function (option) {
    return __assign(__assign({}, option), {
      id: getInputId(option.id)
    });
  });
};

exports["default"] = {
  getInputId: getInputId,
  getFirstId: getFirstId,
  createId: createId,
  getOptionsWithId: getOptionsWithId
};